import { Link_Target } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
const DEFAULT_LINK_VALUE = {
  anchor: void 0,
  rel: {
    noreferrer: true
  },
  target: Link_Target.BLANK,
  url: ""
};
export {
  DEFAULT_LINK_VALUE
};
//# sourceMappingURL=constants.js.map
